export const PERSONAL_DOCUMENTS_OPTIONS = [
	{
		label: 'probationary period',
		value: 'probationary',
	},
	{
		label: 'fixed-term contract',
		value: 'fixed_term',
	},
	{
		label: 'permanent contract',
		value: 'permanent',
	},
	{
		label: 'annex',
		value: 'annex',
	},
];

export const ANNEX_TYPES_OPTIONS = [
	{
		label: 'Change of bonus rate',
		value: 'change_of_bonus_rate',
	},
	{
		label: 'Change of base salary',
		value: 'change_of_base_salary',
	},
	{
		label: 'Change of base salary and bonus',
		value: 'change_of_base_salary_and_bonus',
	},
	{
		label: 'Contract extension',
		value: 'contract_extension',
	},
	{
		label: 'Working Time Adjustment',
		value: 'working_time_adjustment',
	},
];
